// TurnoModal.jsx
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Swal from 'sweetalert2';
import baseURL from '../url';
import "./TurnoModal.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faUser, faCalendarAlt, faTimesCircle, faClock, faListAlt } from '@fortawesome/free-regular-svg-icons';
import { faPlusCircle, faRedo, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import * as XLSX from 'xlsx';
// Importar el ícono de historial de react-icons
import { AiOutlineHistory } from 'react-icons/ai';
import { FaUser, FaPhone, FaBuilding, FaBook, FaUserMd, FaDoorOpen, FaInfoCircle, FaEdit, FaSave, FaClock, FaComment, FaCalendarAlt, FaTools, FaFileExcel as FaFileExcelIcon } from 'react-icons/fa';
// Configurar moment.js para usar el idioma español
moment.locale('es'); // Establecer el idioma a español

const TAB_LIST = [
  { key: 'perfil', label: 'Perfil', icon: faUser, type: 'fa' },
  { key: 'citas', label: 'Citas', icon: faCalendarAlt, type: 'fa' },
  { key: 'historial', label: 'Historial', icon: AiOutlineHistory, type: 'react' },
  //{ key: 'comentarios', label: 'Comentarios', icon: faComment, type: 'fa' },
  { key: 'cancelar', label: 'Cancelar', icon: faTimesCircle, type: 'fa' },
  { key: 'pacientes', label: 'Pacientes', icon: faUser, type: 'fa' },

];

const TurnoModal = ({
  isOpen,
  onClose,
  turnoSeleccionado,
  cargarTurnos,
  nombre,
  setNombre,
  telefono,
  setTelefono,
  motivoInactivo,
  setMotivoInactivo,
  nuevaFecha,
  setNuevaFecha,
  periodicidad,
  setPeriodicidad,
  nuevaHoraInicio,
  setNuevaHoraInicio,
  nuevaHoraFin,
  setNuevaHoraFin,
  nuevoComentario,
  setNuevoComentario,
  comentarioActualizado,
  cancelarActualizado,
  nuevoEstado,
  setNuevoEstado,
  categorias,
  categoriaSeleccionada,
  setCategoriaSeleccionada,
  servicioSeleccionado,
  setServicioSeleccionado,
  terapeutaSeleccionado,
  setTerapeutaSeleccionado,
  salaSeleccionada,
  setSalaSeleccionada,
  citasSeleccionadas,
  setCitasSeleccionadas,
  alertAsignarSala,
  handleUpdateText,
  handleUpdateDate,
  handleInsertComment,
  handleNewAppointment,
  handleCancelar
}) => {

  const [salas, setSalas] = useState([]);
  const [salasDisponibles, setSalasDisponibles] = useState([]);
  const [listaTerapeutas, setListaTerapeutas] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [catalogoMotivosInactivo, setCatalogoMotivosInactivo] = useState([]);
  const [comentarios, setComentarios] = useState([]);
  const [citasProgramadas, setCitasProgramadas] = useState([]);
  const [citasHistorial, setCitasHistorial] = useState([]);
  const [pacientes, setPacientes] = useState([]);
  const [allPacientes, setAllPacientes] = useState([]);
  const [modalSeleccionarPacienteIsOpen, setModalSeleccionarPacienteIsOpen] = useState(false);
  const [pacienteSeleccionado, setPacienteSeleccionado] = useState('');
  const [excelFile, setExcelFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setExcelFile(file);
      handleExcelUpload(file);
      // Limpiar el valor del input para permitir seleccionar el mismo archivo de nuevo
      e.target.value = null;
    }
  };

  const handleExcelUpload = (file) => {
    if (!file) {
      Swal.fire('Error', 'No se ha seleccionado ningún archivo', 'error');
      return;
    }

    // Verificar la extensión del archivo
    const fileExt = file.name.split('.').pop().toLowerCase();
    if (!['xls', 'xlsx'].includes(fileExt)) {
      Swal.fire('Error', 'Formato de archivo no válido. Por favor, sube un archivo Excel (.xls o .xlsx)', 'error');
      return;
    }

    setIsUploading(true);
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        console.log('Iniciando lectura del archivo Excel...');
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        console.log('Hojas en el archivo:', workbook.SheetNames);

        if (workbook.SheetNames.length === 0) {
          throw new Error('El archivo no contiene hojas');
        }

        const firstSheetName = workbook.SheetNames[0];
        console.log('Usando hoja:', firstSheetName);

        const worksheet = workbook.Sheets[firstSheetName];

        // Leer como JSON con encabezados en la primera fila
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        if (jsonData.length <= 1) { // 1 fila de encabezados + al menos 1 fila de datos
          throw new Error('El archivo está vacío o solo contiene encabezados');
        }

        // Obtener los encabezados (primera fila) y normalizarlos (sin tildes y en minúsculas)
        const normalizeText = (text) => {
          return text.toString().trim().toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // Eliminar tildes
        };

        const headers = jsonData[0].map(h => h ? normalizeText(h) : '');
        console.log('Encabezados encontrados:', headers);

        // Verificar que existan las columnas mínimas requeridas
        const requiredColumns = ['nombre', 'telefono', 'sexo', 'edad'];
        const headerMap = {}; // Mapa para rastrear los nombres de columnas originales

        // Crear un mapeo de columnas normalizadas a originales
        jsonData[0].forEach((original, index) => {
          if (original) {
            const normalized = normalizeText(original);
            headerMap[normalized] = original;
          }
        });

        // Verificar columnas faltantes
        const missingColumns = [];
        requiredColumns.forEach(col => {
          if (!headers.includes(col)) {
            missingColumns.push(col);
          }
        });

        if (missingColumns.length > 0) {
          throw new Error(`Faltan columnas requeridas: ${missingColumns.join(', ')}`);
        }

        // Convertir a array de objetos con los nombres de las columnas normalizados
        const formattedData = [];

        // Empezar desde 1 para saltar la fila de encabezados
        for (let i = 1; i < jsonData.length; i++) {
          const row = jsonData[i];
          const item = {};

          // Usar los nombres de columna normalizados para el objeto final
          requiredColumns.forEach(col => {
            const colIndex = headers.indexOf(col);
            if (colIndex !== -1 && row[colIndex] !== undefined) {
              item[col] = row[colIndex] !== null ? row[colIndex].toString().trim() : '';
            } else {
              item[col] = ''; // Valor por defecto si la columna no existe
            }
          });

          // Solo agregar si tiene nombre y teléfono
          if (item.nombre && item.telefono && item.sexo && item.edad) {
            formattedData.push(item);
          }
        }

        console.log('Datos procesados:', formattedData);

        if (formattedData.length === 0) {
          throw new Error('No se encontraron registros válidos en el archivo');
        }

        // Mostrar resumen antes de procesar
        Swal.fire({
          title: '¿Continuar?',
          html: `Se procesarán <b>${formattedData.length}</b> registros. ¿Deseas continuar?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sí, continuar',
          cancelButtonText: 'Cancelar'
        }).then((result) => {
          if (result.isConfirmed) {
            processExcelData(formattedData);
          } else {
            setIsUploading(false);
          }
        });

      } catch (error) {
        console.error('Error al procesar el archivo Excel:', error);
        Swal.fire({
          title: 'Error',
          text: error.message || 'Error al procesar el archivo Excel',
          icon: 'error'
        });
        setIsUploading(false);
      }
    };

    reader.onerror = (error) => {
      console.error('Error al leer el archivo:', error);
      Swal.fire({
        title: 'Error',
        text: 'Error al leer el archivo. Asegúrate de que no esté dañado o en uso por otro programa.',
        icon: 'error'
      });
      setIsUploading(false);
    };

    try {
      reader.readAsArrayBuffer(file);
    } catch (error) {
      console.error('Error al iniciar la lectura del archivo:', error);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo leer el archivo. Verifica que sea un archivo Excel válido.',
        icon: 'error'
      });
      setIsUploading(false);
    }
  };

  const processExcelData = async (patients) => {
    try {
      const formData = new FormData();
      formData.append('idTaller', turnoSeleccionado.idTaller);
      formData.append('taller', turnoSeleccionado.nombreTaller);
      formData.append('dias', JSON.stringify(turnoSeleccionado.dias));
      formData.append('periodicidad', turnoSeleccionado.periodicidad);

      // Add patients data
      formData.append('pacientes', JSON.stringify(patients));

      const response = await fetch(`${baseURL}/pacientesExcelTallerPost.php`, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (data.error) {
        throw new Error(data.error);
      }

      Swal.fire('¡Éxito!', 'Pacientes cargados correctamente', 'success');
      cargarPacientes();
      cargarTurnos();
    } catch (error) {
      console.error('Error al cargar pacientes desde Excel:', error);
      Swal.fire('Error', 'Error al cargar pacientes desde Excel: ' + error.message, 'error');
    } finally {
      setIsUploading(false);
    }
  };

  const inscribirPacienteExistente = (paciente) => {
    const formData = new FormData();

    // Datos del paciente
    formData.append('idPaciente', paciente.id);
    formData.append('nombrePaciente', paciente.nombre);
    formData.append('telefono', paciente.telefono || '');

    // Datos del taller
    formData.append('idTaller', turnoSeleccionado.idTaller);
    formData.append('taller', turnoSeleccionado.nombreTaller);
    formData.append('dias', JSON.stringify(turnoSeleccionado.dias));
    formData.append('periodicidad', turnoSeleccionado.periodicidad);

    // Enviar a la API
    fetch(`${baseURL}/pacienteExistenteTallerPost.php`, {
      method: 'POST',
      body: formData
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Error en la solicitud');
        }
        return response.json();
      })
      .then(data => {
        if (data.error) {
          Swal.fire('Error', data.error, 'error');
        } else {
          Swal.fire('¡Éxito!', 'Paciente inscrito al taller correctamente', 'success');
          cargarPacientes();
          cargarTurnos();
          setModalSeleccionarPacienteIsOpen(false);
        }
      })
      .catch(error => {
        console.error('Error al inscribir paciente:', error);
        Swal.fire('Error', 'Ocurrió un error al inscribir al paciente', 'error');
      });
  };

  const [modalDatosPacienteIsOpen, setModalDatosPacienteIsOpen] = useState(false);

  const [catalogoEscolaridad, setCatalogoEscolaridad] = useState([]);
  const [catalogoEstadoCivil, setCatalogoEstadoCivil] = useState([]);
  const [catalogoMotivosConsulta, setCatalogoMotivosConsulta] = useState([]);
  const [catalogoMunicipios, setCatalogoMunicipios] = useState([]);
  const [catalogoReligiones, setCatalogoReligiones] = useState([]);
  const [catalogoServiciosSalud, setCatalogoServiciosSalud] = useState([]);
  const [catalogoSexo, setCatalogoSexo] = useState([]);
  const [catalogoComoEntero, setCatalogoComoEntero] = useState([]);

  const [idPacienteSeleccionado, setIdPacienteSeleccionado] = useState("");
  const [nombrePaciente, setNombrePaciente] = useState("");
  const [telefonoPaciente, setTelefonoPaciente] = useState("");
  const [edadPaciente, setEdadPaciente] = useState("");
  const [ocupacion, setOcupacion] = useState("");
  const [sexo, setSexo] = useState("");
  const [escolaridad, setEscolaridad] = useState("");
  const [estadoCivil, setEstadoCivil] = useState("");
  const [servicioSalud, setServicioSalud] = useState("");
  const [religion, setReligion] = useState("");
  const [municipio, setMunicipio] = useState("");
  const [motivoConsulta, setMotivoConsulta] = useState("");
  const [comoEntero, setComoEntero] = useState("");

  const [tab, setTab] = useState('perfil');
  const [btnEstado, setBtnEstado] = useState();
  const [btnFecha, setBtnFecha] = useState();

  const [nombreCategoria, setNombreCategoria] = useState();
  const [nombreServicio, setNombreServicio] = useState();
  const [nombreTerapeuta, setNombreTerapeuta] = useState();
  const [estado, setEstado] = useState();

  const [opcionCrud, setOpcionCrud] = useState(); //Nuevo, Existente

  const horas = ["08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00"];

  const [selecciones, setSelecciones] = useState();

  const isDisabled = citasSeleccionadas.length === 0;

  const obtenerServicios = async () => {

    setServicios([]);

    try {

      fetch(`${baseURL}/serviciosCategoriaGet.php?idTienda=${categoriaSeleccionada}`, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(data => {
          if (data.error) {
            Swal.fire({
              icon: 'warning',
              title: 'Error al cargar CESECOS',
              text: data.error,
            });
          } else {
            setServicios(data.servicios || []);
          }

        })
        .catch(error => console.error('Error al cargar programas:', error));


    } catch (error) {
      console.error('Error al obtener los progamas disponibles:', error);
    }

  };

  const cargarTerapeutas = async () => {

    setListaTerapeutas([]);

    try {
      fetch(`${baseURL}/terapeutasPorPrograma.php?idServicio=${servicioSeleccionado}`, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(data => {

          if (data.error) {
            Swal.fire({
              icon: 'warning',
              title: 'Error al cargar terapeutas',
              text: data.error,
            });
          } else {
            setListaTerapeutas(data || []);
          }

        })
        .catch(error => console.error('Error al cargar terapeutas:', error));

    } catch (error) {
      console.error('Error al obtener terapeutas:', error);
    }


  };

  const cargarPacientes = () => {
    //pacientes del taller
    fetch(`${baseURL}/pacientesPorTallerGet.php?idTaller=${turnoSeleccionado.idTaller}&fecha=${turnoSeleccionado.dias[0].dia}&hora=${turnoSeleccionado.dias[0].horaInicio}`, {
      method: 'GET',
    })
      .then(response => response.json())
      .then(data => {
        setPacientes(data.pacientes || []);
      })
      .catch(error => console.error('Error al cargar pacientes del taller:', error));

    //todos los pacientes
    fetch(`${baseURL}/pacientesGet.php`, {
      method: 'GET',
    })
      .then(response => response.json())
      .then(data => {
        setAllPacientes(data.pacientes || []);
      })
      .catch(error => console.error('Error al cargar todos los pacientes:', error));
  };

  /*
  const obtenerComentarios = async () => {

    setComentarios([]);

    if (turnoSeleccionado.idPaciente != null) {
      try {
        fetch(`${baseURL}/comentariosGet.php?idPaciente=${turnoSeleccionado.idPaciente}`, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              Swal.fire({
                icon: 'warning',
                title: 'Error al cargar comentarios',
                text: data.error,
              });
            } else {
              setComentarios(data.comentarios);
            }

          })
          .catch(error => console.error('Error al cargar comentarios:', error));

      } catch (error) {
        console.error('Error al obtener comentarios:', error);
      }
    }

  };
  */
  const obtenerCitasProgramadas = async () => {

    setCitasProgramadas([]);

    if (turnoSeleccionado.idPaciente != null) {
      try {
        fetch(`${baseURL}/turnosTalleresPorPacienteGet.php?idPaciente=${turnoSeleccionado.idPaciente}`, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              Swal.fire({
                icon: 'warning',
                title: 'Error al cargar las citas programadas',
                text: data.error,
              });
            } else {
              const citasConDiasParseado = data.turnos.map((cita) => ({
                ...cita,
                dias: JSON.parse(cita.dias)
              }));
              setCitasProgramadas(citasConDiasParseado);
            }

          })
          .catch(error => console.error('Error al cargar las citas programadas:', error));

      } catch (error) {
        console.error('Error al obtener las citas programadas:', error);
      }
    }
  };

  const obtenerCitasHistorial = async () => {

    setCitasHistorial([]);

    if (turnoSeleccionado.idPaciente != null) {
      try {
        fetch(`${baseURL}/turnosTalleresHistorialGet.php?idPaciente=${turnoSeleccionado.idPaciente}`, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              Swal.fire({
                icon: 'warning',
                title: 'Error al cargar historial de citas',
                text: data.error,
              });
            } else {
              const citasConDiasParseado = data.turnos.map((cita) => ({
                ...cita,
                dias: JSON.parse(cita.dias)
              }));
              setCitasHistorial(citasConDiasParseado);
            }

          })
          .catch(error => console.error('Error al cargar historial de citas:', error));

      } catch (error) {
        console.error('Error al obtener historial de citas:', error);
      }
    }
  };

  const obtenerSalasDisponibles = async () => {

    setSalas([]);
    setSalasDisponibles([]);

    if (turnoSeleccionado && categoriaSeleccionada > 0 && turnoSeleccionado.dias && turnoSeleccionado.dias.length > 0 && terapeutaSeleccionado) {
      try {
        const { dia, horaInicio, horaFin } = turnoSeleccionado.dias[0];

        fetch(`${baseURL}/salasDisponiblesGet.php?fecha=${dia}&horaInicio=${horaInicio}&horaFin=${horaFin}&idCategoria=${categoriaSeleccionada}&idTerapeuta=${terapeutaSeleccionado}&idTurno=${turnoSeleccionado.idTurno}`, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              if (turnoSeleccionado.estado != 'Asignado') {
                Swal.fire({
                  icon: 'warning',
                  title: '',
                  text: data.error,
                });
              }
            } else {
              setSalas(data.salas || []);
              setSalasDisponibles(data.salasDisponibles || []);

            }

          })
          .catch(error => console.error('Error al cargar salas disponibles:', error));


      } catch (error) {
        console.error('Error al obtener las salas disponibles:', error);
      }
    }
  };

  const cargarCatalogos = () => {
    //MOTIVO INACTIVO
    fetch(`${baseURL}/catalogoGet.php?nombre_catalogo=motivos_inactivo`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoMotivosInactivo(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo motivos_inactivo:', error));

    //ESCOLARIDAD
    fetch(`${baseURL}/catalogoGet.php?nombre_catalogo=escolaridad`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoEscolaridad(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo escolaridad:', error));

    //ESTADO CIVIL    
    fetch(`${baseURL}/catalogoGet.php?nombre_catalogo=estado_civil`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoEstadoCivil(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo estado civil:', error));

    //MOTIVOS DE CONSULTA    
    fetch(`${baseURL}/catalogoGet.php?nombre_catalogo=motivos_de_consulta`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoMotivosConsulta(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo motivos de consulta:', error));

    //MUNICIPIOS    
    fetch(`${baseURL}/catalogoGet.php?nombre_catalogo=municipios`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoMunicipios(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo municipios:', error));

    //RELIGIONES    
    fetch(`${baseURL}/catalogoGet.php?nombre_catalogo=religiones`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoReligiones(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo religiones:', error));

    //SERVICIOS DE SALUD   
    fetch(`${baseURL}/catalogoGet.php?nombre_catalogo=servicios_de_salud`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoServiciosSalud(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo servicios de salud:', error));

    //SEXO   
    fetch(`${baseURL}/catalogoGet.php?nombre_catalogo=sexo`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoSexo(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo sexo:', error));

    //COMO ENTERO
    fetch(`${baseURL}/catalogoGet.php?nombre_catalogo=como_entero`)
      .then(res => res.json())
      .then(data => setCatalogoComoEntero(data.catalogo || []));

  };

  const checkDatosCompletos = () => {
    /*
    if (nombre == '' || nombre == null) {
      Swal.fire('Atención!', 'Debes escribir el nombre del paciente', 'alert');
    } else if (telefono == '' || telefono == null) {
      Swal.fire('Atención!', 'Debes escribir el teléfono del paciente', 'alert');
    } else if (servicioSeleccionado == null || servicioSeleccionado == '') {
      Swal.fire('Atención!', 'Debes seleccionar un programa', 'alert');
    } else if (nuevoEstado == 'Asignado' && (terapeutaSeleccionado == null || terapeutaSeleccionado == '')) {
      Swal.fire('Atención!', 'Debes seleccionar un terapeuta', 'alert');
    } else if (nuevoEstado == 'Asignado' && (salaSeleccionada == null || salaSeleccionada == '')) {
      Swal.fire('Atención!', 'Debes seleccionar una sala', 'alert');
    } else if ((nuevoEstado == 'Inactivo' || nuevoEstado == 'Finalizado') && (motivoInactivo == null || motivoInactivo == '')) {
      Swal.fire('Atención!', 'Debes seleccionar un motivo', 'alert');
    } else {
      setBtnEstado('Editar');
      //alertAsignarSala(turnoSeleccionado);
      handleUpdateText(turnoSeleccionado.idTurno);

    }
    */
    setBtnEstado('Editar');
    handleUpdateText(turnoSeleccionado.idTurno);

  }

  const checkComentarioCompleto = (tipo) => {
    if (nuevoComentario == '' || nuevoComentario == null) {
      Swal.fire('Atención!', 'Debes escribir un comentario', 'alert');
    } else {
      handleInsertComment(turnoSeleccionado.idTurno, tipo);
    }
  }

  const checkDatosPrograma = () => {

    if (nuevaFecha == '' || nuevaFecha == null) {
      Swal.fire('Atención!', 'Debes seleccionar una fecha', 'alert');
    } else if (periodicidad == '' || periodicidad == null) {
      Swal.fire('Atención!', 'Debes seleccionar la periodicidad', 'alert');
    } else {
      setBtnFecha('Editar');
      //alertAsignarSala(turnoSeleccionado);
      handleUpdateDate(turnoSeleccionado.idTurno);
    }
  }

  const handleAgregarUnaCita = async () => {
    // Calcular la próxima cita a agendar
    let fechaBase = nuevaFecha;
    if (citasProgramadas.length > 0) {
      // Tomar la última cita futura
      const ultCita = citasProgramadas[citasProgramadas.length - 1];
      fechaBase = ultCita.dias[0].dia;
    }
    // Calcular la siguiente fecha según periodicidad
    let siguienteFecha = moment(fechaBase);
    if (periodicidad === 'Semanal') {
      siguienteFecha = siguienteFecha.add(7, 'days');
    } else if (periodicidad === 'Quincenal') {
      siguienteFecha = siguienteFecha.add(14, 'days');
    }
    const diaSemana = siguienteFecha.format('dddd');
    const fechaStr = siguienteFecha.format('D [de] MMMM [de] YYYY');
    const horaInicio = nuevaHoraInicio;
    const horaFin = nuevaHoraFin;
    // Mostrar confirmación
    const result = await Swal.fire({
      title: '¿Agregar una nueva cita?',
      html: `<b>Fecha:</b> ${fechaStr}<br/><b>Día:</b> ${diaSemana}<br/><b>Hora:</b> ${horaInicio} - ${horaFin}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, agendar',
      cancelButtonText: 'Cancelar',
    });
    if (result.isConfirmed) {
      setNuevoComentario("");
      //await handleInsertComment(turnoSeleccionado.idTurno, 4);
      await handleNewAppointment(turnoSeleccionado.idTurno);
      await obtenerCitasProgramadas();
    }
  };

  useEffect(() => {
    if (isOpen) {
      setNombre(turnoSeleccionado?.nombre || '');
      setTelefono(turnoSeleccionado?.telefono || '');

      setCategoriaSeleccionada(turnoSeleccionado?.idCategoriaSala || '');
      setServicioSeleccionado(turnoSeleccionado?.idServicio || '');
      setTerapeutaSeleccionado(turnoSeleccionado?.idTerapeuta || '');
      setSalaSeleccionada(turnoSeleccionado?.idSala || '');

      setNuevaFecha(turnoSeleccionado.dias[0].dia);
      setPeriodicidad(turnoSeleccionado.periodicidad);
      setNuevaHoraInicio(turnoSeleccionado.dias[0].horaInicio);
      setNuevaHoraFin(turnoSeleccionado.dias[0].horaFin);

      setNuevoEstado(turnoSeleccionado?.estado || '');

      setNombreCategoria(turnoSeleccionado?.nombreCategoria || '');
      setNombreServicio(turnoSeleccionado?.servicio || '');
      setNombreTerapeuta(turnoSeleccionado?.nombreTerapeuta || '');
      setEstado(turnoSeleccionado?.estado || '');

      setBtnEstado('Editar');
      setBtnFecha('Editar')
      setTab('perfil');
      setSelecciones({ todas: false });
      setCitasSeleccionadas([]);

      setNuevoComentario("");

      cargarCatalogos();
      cargarPacientes();
      //obtenerComentarios();
      obtenerCitasProgramadas();
      obtenerCitasHistorial();

    }

  }, [isOpen, turnoSeleccionado]);


  useEffect(() => {
    if (!isOpen) return;
    obtenerServicios();

  }, [isOpen, categoriaSeleccionada]);

  const handleCategoriaSeleccionada = (e) => {
    setCategoriaSeleccionada(e.target.value)
    setServicioSeleccionado(null);
    obtenerServicios();
  }

  useEffect(() => {
    if (!isOpen) return;
    cargarTerapeutas();
  }, [isOpen, servicioSeleccionado]);

  const handleServicioSeleccionado = (e) => {
    setServicioSeleccionado(e.target.value)
    setTerapeutaSeleccionado(null);
    cargarTerapeutas();
  }

  useEffect(() => {
    if (!isOpen) return;
    obtenerSalasDisponibles();
  }, [isOpen, terapeutaSeleccionado]);


  useEffect(() => {
    if (isOpen) {
      //obtenerComentarios();
    }
  }, [comentarioActualizado]);

  useEffect(() => {
    if (isOpen) {
      obtenerCitasProgramadas();
    }
  }, [cancelarActualizado]);


  const handleTerapeutaSeleccionado = (e) => {
    setTerapeutaSeleccionado(e.target.value)
    setSalaSeleccionada(null);
    obtenerSalasDisponibles();
  }


  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;

    if (value === "todas") {

      const todosIds = citasProgramadas.map(cita => cita.idTurno);
      setCitasSeleccionadas(todosIds);
      setSelecciones({ todas: checked });
    } else {

      const idCita = Number(value);
      let nuevasCitas = [...citasSeleccionadas];
      if (checked) {
        nuevasCitas.push(idCita);
      } else {
        nuevasCitas = nuevasCitas.filter((id) => id !== idCita);
      }

      setCitasSeleccionadas(nuevasCitas);
      setSelecciones({ todas: false });
    }
  };

  const handleCloseDatosPacienteModal = () => {
    setModalDatosPacienteIsOpen(false); // Cerrar el modal
  };

  const handleOpenDatosPacienteNuevoModal = () => {
    setOpcionCrud("Nuevo");

    setNombrePaciente("");
    setTelefonoPaciente("");
    setEdadPaciente("");
    setSexo("");
    setEscolaridad("");
    setEstadoCivil("");
    setOcupacion("");
    setServicioSalud("");
    setReligion("");
    setMunicipio("");
    setMotivoConsulta("");
    setComoEntero("");

    setModalDatosPacienteIsOpen(true);
  };

  const handleOpenDatosPacienteExistenteModal = (id) => {

    const paciente = pacientes.filter(item => item.id === id);

    setOpcionCrud("Existente");

    setIdPacienteSeleccionado(paciente[0].id);
    setNombrePaciente(paciente[0].nombre);
    setTelefonoPaciente(paciente[0].telefono);
    setEdadPaciente(paciente[0].edad);
    setSexo(paciente[0].idSexo || 0);
    setEscolaridad(paciente[0].idEscolaridad || 0);
    setEstadoCivil(paciente[0].idEstadoCivil || 0);
    setOcupacion(paciente[0].ocupacion);
    setServicioSalud(paciente[0].idServicioSalud || 0);
    setReligion(paciente[0].idReligion || 0);
    setMunicipio(paciente[0].idMunicipio || 0);
    setMotivoConsulta(paciente[0].idMotivoConsulta || 0);
    setComoEntero(paciente[0].idComoEntero || 0);

    setModalDatosPacienteIsOpen(true);
  };

  const borrarPaciente = async (id, name) => {
    const result = await Swal.fire({
      title: '¿Deseas borrar el paciente?',
      html: `<b>${name}<b>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, borrarlo',
      cancelButtonText: 'Cancelar',
    });
    if (result.isConfirmed) {
      fetch(`${baseURL}/pacientesTallerDelete.php?idPaciente=${id}&idTaller=${turnoSeleccionado.idTaller}&fecha=${turnoSeleccionado.dias[0].dia}&horaInicio=${turnoSeleccionado.dias[0].horaInicio}`, {
        method: 'DELETE',
      }).then(response => response.json())
        .then(data => {
          if (data.error) {
            Swal.fire(
              'Error',
              data.error,
              'error'
            );
          } else {
            Swal.fire(
              '¡Eliminado!',
              data.mensaje,
              'success'
            );
            cargarPacientes();
          }
        }).catch(error => {
          console.error('Error al eliminar paciente:', error);
          Swal.fire(
            'Error',
            'Ocurrió un problema al intentar eliminar el paciente.',
            'error'
          );
        });
    }
  }

  const guardarPaciente = () => {
    if (nombrePaciente == '') {
      Swal.fire('Alerta!', 'Debes escribir el nombre del paciente', 'alert');
    } else if (telefonoPaciente == '') {
      Swal.fire('Alerta!', 'Debes escribir el teléfono del paciente', 'alert');
    } else if (edadPaciente == '') {
      Swal.fire('Alerta!', 'Debes escribir la edad del paciente', 'alert');
    } else if (sexo == '') {
      Swal.fire('Alerta!', 'Debes seleccionar una opción en sexo', 'alert');
    } else {

      if (opcionCrud === "Nuevo") {
        const formData = new FormData();

        formData.append('nombrePaciente', nombrePaciente);
        formData.append('telefono', telefonoPaciente);
        formData.append('edad', edadPaciente);
        formData.append('sexo', sexo);
        formData.append('escolaridad', escolaridad);
        formData.append('estadoCivil', estadoCivil);
        formData.append('ocupacion', ocupacion);
        formData.append('servicioSalud', servicioSalud);
        formData.append('religion', religion);
        formData.append('municipio', municipio);
        formData.append('motivoConsulta', motivoConsulta);
        formData.append('comoEntero', comoEntero);

        formData.append('idTaller', turnoSeleccionado.idTaller);
        formData.append('taller', turnoSeleccionado.nombreTaller);
        formData.append('dias', JSON.stringify(turnoSeleccionado.dias));
        formData.append('periodicidad', turnoSeleccionado.periodicidad);

        //damos de alta el paciente y lo inscribimos al taller
        fetch(`${baseURL}/pacienteTallerPost.php`, {
          method: 'POST',
          body: formData
        }).then(response => {
          if (!response.ok) {
            throw new Error('La solicitud no fue exitosa');
          }
          return response.json();
        })
          .then(data => {
            if (data.error) {
              Swal.fire('Error!', data.error, 'error');
            } else {
              Swal.fire('Aviso!', data.mensaje, 'success');
              cargarPacientes();
              cargarTurnos();
              handleCloseDatosPacienteModal();
            }
          })
          .catch(error => {
            Swal.fire('Error!', error.message, 'error');
          });
      } else {
        const payload = {
          nombrePaciente,
          telefono: telefonoPaciente,
          edad: edadPaciente,
          sexo,
          escolaridad,
          estadoCivil,
          ocupacion,
          servicioSalud,
          religion,
          municipio,
          motivoConsulta,
          comoEntero,
        };

        fetch(`${baseURL}/pacienteSinTurnoPut.php?idPaciente=${idPacienteSeleccionado}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }).then(response => {
          if (!response.ok) {
            throw new Error('La solicitud no fue exitosa');
          }
          return response.json();
        })
          .then(data => {
            if (data.error) {
              Swal.fire('Error!', data.error, 'error');
            } else {
              Swal.fire('Aviso!', data.mensaje, 'success');
              cargarPacientes();
              handleCloseDatosPacienteModal();
            }
          })
          .catch(error => {
            Swal.fire('Error!', error.message, 'error');
          });
      }

    }

  };


  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        contentLabel="Detalle de la cita"
        ariaHideApp={false}
        className="modal-admin"
        overlayClassName="overlay-admin"
      >
        {/* HEADER */}
        <div className='deFlexBtnsModal'>

          {/*
          <div className='deFlexBtnsModal'>
            <div className="patientPhoto" />
            <div className="patientData">
              <h4>{turnoSeleccionado.nombre}</h4>
              <span>ID: {turnoSeleccionado.idTurno}</span>
            </div>
            <div className="bookStatus">
              <span>Estatus del paciente:</span>
              <span className="status">{estado}</span>
              <span className="motivo-inactivo">{turnoSeleccionado.motivo_inactivo}</span>
            </div>
          </div>
          */}

          <span className="close" onClick={onClose}>&times;</span>
        </div>

        {/* TABS SUPERIORES */}
        <div className="tabs">
          {TAB_LIST.map(tabItem => (
            <button
              key={tabItem.key}
              className={`tab-label${tab === tabItem.key ? ' active' : ''}`}
              onClick={() => setTab(tabItem.key)}
            >
              {tabItem.type === 'fa' ? (
                <FontAwesomeIcon icon={tabItem.icon} style={{ marginRight: 8 }} />
              ) : (
                <tabItem.icon style={{ marginRight: 8, fontSize: 18, verticalAlign: 'middle' }} />
              )}
              {tabItem.label}
            </button>
          ))}
        </div>

        {/* CONTENIDO DE TABS */}
        <div className="tab-content">
          {/* PERFIL */}
          {tab === 'perfil' && (
            <div className="profile-card">
              {btnEstado === 'Editar' ? (
                <>
                  {/*}
                  <div className="profile-field">
                    <FaUser className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Nombre completo *</span>
                      <span className="profile-value">{nombre}</span>
                    </div>
                  </div>
                  <div className="profile-field">
                    <FaPhone className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Teléfono de contacto *</span>
                      <span className="profile-value">{telefono}</span>
                    </div>
                  </div>
                  {*/}
                  <div className="profile-field">
                    <FaTools className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Taller *</span>
                      <span className="profile-value">{turnoSeleccionado.nombreTaller}</span>
                    </div>
                  </div>
                  <div className="profile-field">
                    <FaBuilding className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Unidad CESECO *</span>
                      <span className="profile-value">{nombreCategoria}</span>
                    </div>
                  </div>
                  <div className="profile-field">
                    <FaBook className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Programa *</span>
                      <span className="profile-value">{nombreServicio}</span>
                    </div>
                  </div>
                  <div className="profile-field">
                    <FaUserMd className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Terapeuta *</span>
                      <span className="profile-value">{nombreTerapeuta}</span>
                    </div>
                  </div>
                  <div className="profile-field">
                    <FaDoorOpen className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Sala *</span>
                      <span className="profile-value">{turnoSeleccionado?.nombreSala}</span>
                    </div>
                  </div>

                  {/*}
                  <div className="profile-field">
                    <FaInfoCircle className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Estado *</span>
                      <span className="profile-value">{estado}</span>
                    </div>
                  </div>
                  {(nuevoEstado === 'Inactivo' || nuevoEstado === 'Finalizado') && (
                    <div className="profile-field">
                      <FaInfoCircle className="profile-icon" />
                      <div style={{ flex: 1 }}>
                        <span className="profile-label">Motivo *</span>
                        <span className="profile-value">{motivoInactivo}</span>
                      </div>
                    </div>
                  )}
                  {*/}


                </>
              ) : (
                <>
                  {/*}
                <div className="profile-field">
                  <FaUser className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Nombre completo *</span>
                    <span className="profile-input-icon"><FaUser /></span>
                    <input className="profile-input" type="text" value={nombre} onChange={e => setNombre(e.target.value)} style={{ paddingLeft: 38 }} />
                  </div>
                </div>
                <div className="profile-field">
                  <FaPhone className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Teléfono de contacto *</span>
                    <span className="profile-input-icon"><FaPhone /></span>
                    <input className="profile-input" type="text" value={telefono} onChange={e => setTelefono(e.target.value)} style={{ paddingLeft: 38 }} />
                  </div>
                </div>
                <div className="profile-field">
                  <FaBuilding className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Unidad CESECO *</span>
                    <span className="profile-input-icon"><FaBuilding /></span>
                    <select
                      className="profile-select"
                      value={categoriaSeleccionada || ""}
                      onChange={handleCategoriaSeleccionada}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccionar CESECO</option>
                      {categorias.map(c => (
                        <option key={c.idCategoria} value={c.idCategoria}>
                          {c.categoria}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="profile-field">
                  <FaBook className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Programa *</span>
                    <span className="profile-input-icon"><FaBook /></span>
                    <select
                      className="profile-select"
                      value={servicioSeleccionado || ""}
                      onChange={handleServicioSeleccionado}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccionar Programa</option>
                      {servicios.map(s => (
                        <option key={s.idServicio} value={s.idServicio}>
                          {s.titulo}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="profile-field">
                  <FaUserMd className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Asignar a *</span>
                    <span className="profile-input-icon"><FaUserMd /></span>
                    <select
                      className="profile-select"
                      value={terapeutaSeleccionado || ""}
                      onChange={handleTerapeutaSeleccionado}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccionar usuario</option>
                      {listaTerapeutas.map(t => {
                        const rolLabel = t.rol === 'terapeuta' ? 'Terapeuta' :
                                        t.rol === 'coord_programa' ? 'Coord. Programa' :
                                        t.rol === 'coord_ceseco' ? 'Coord. CESECO' : t.rol;
                        return (
                          <option key={t.idUsuario} value={t.idUsuario}>
                            {t.nombre} ({rolLabel})
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="profile-field">
                  <FaDoorOpen className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Sala *</span>
                    <span className="profile-input-icon"><FaDoorOpen /></span>
                    <select
                      className="profile-select"
                      value={salaSeleccionada || ""}
                      onChange={e => setSalaSeleccionada(e.target.value)}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccione una sala</option>
                      {salas.map((s) => {
                        const estaDisponible = salasDisponibles.some(sd => sd.idSala === s.idSala);
                        return (
                          <option
                            key={s.idSala}
                            value={s.idSala}
                            disabled={!estaDisponible}
                          >
                            {s.nombre} {estaDisponible ? '' : '(No disponible)'}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                {*/}
                  <div className="profile-field">
                    <FaInfoCircle className="profile-icon" />
                    <div style={{ flex: 1, position: 'relative' }}>
                      <span className="profile-label">Estado *</span>
                      <span className="profile-input-icon"><FaInfoCircle /></span>
                      <select
                        className="profile-select"
                        value={nuevoEstado}
                        onChange={e => setNuevoEstado(e.target.value)}
                        required
                        style={{ paddingLeft: 38 }}
                      >
                        <option value="Pendiente">Pendiente</option>
                        <option value="Asignado">Asignado</option>
                        <option value="Finalizado">Finalizado</option>
                        <option value="Inactivo">Inactivo</option>
                      </select>
                    </div>
                  </div>
                  {/*(nuevoEstado === 'Inactivo' || nuevoEstado === 'Finalizado') && (
                    <div className="profile-field">
                      <FaInfoCircle className="profile-icon" />
                      <div style={{ flex: 1, position: 'relative' }}>
                        <span className="profile-label">Motivo *</span>
                        <span className="profile-input-icon"><FaInfoCircle /></span>
                        <select
                          className="profile-select"
                          value={motivoInactivo || ""}
                          onChange={e => setMotivoInactivo(e.target.options[e.target.selectedIndex].text)}
                          required
                          style={{ paddingLeft: 38 }}
                        >
                          <option value="" disabled>Seleccione un motivo</option>
                          {catalogoMotivosInactivo.map((cat) => (
                            <option key={cat.id} value={cat.id}>{cat.nombre}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )*/}
                </>
              )}
              {/*
              <div className="profile-save-btn-container">
                <button className="profile-edit-btn" onClick={() => {
                  if (btnEstado === 'Editar') {
                    setBtnEstado('Guardar');
                  } else {
                    checkDatosCompletos();
                  }
                }}>
                  {btnEstado === 'Editar' ? <FaEdit style={{ marginRight: 6 }} /> : <FaSave style={{ marginRight: 6 }} />}
                  {btnEstado === 'Editar' ? 'Editar' : 'Guardar'}
                </button>
              </div>
              */}
            </div>
          )}

          {/* CITAS */}
          {tab === 'citas' && (
            <div className="card-section citas-modern">
              <div className="citas-header-row">
                <div className="citas-header-title">
                  <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#14a7a3', marginRight: 8, fontSize: 22 }} />
                  <span style={{ fontWeight: 700, fontSize: 18 }}>Próxima cita</span>
                </div>
                <button className="section-edit-btn" onClick={() => {
                  if (btnFecha === 'Editar') {
                    setBtnFecha('Guardar');
                  } else {
                    checkDatosPrograma();
                  }
                }}>
                  {btnFecha === 'Editar' ? <FaEdit style={{ marginRight: 6 }} /> : <FaSave style={{ marginRight: 6 }} />}
                  {btnFecha === 'Editar' ? 'Editar' : 'Guardar'}
                </button>
              </div>
              <div className="citas-fields-row">
                {btnFecha === 'Editar' ? (
                  <>
                    <div className="cita-field-card">
                      <FontAwesomeIcon icon={faCalendarAlt} className="cita-icon" />
                      <div>
                        <div className="cita-label">Fecha</div>
                        <div className="cita-value">{moment(turnoSeleccionado.dias[0].dia).format('dddd D [de] MMMM [de] YYYY')}</div>
                      </div>
                    </div>
                    <div className="cita-field-card">
                      <FontAwesomeIcon icon={faClock} className="cita-icon" />
                      <div>
                        <div className="cita-label">Hora</div>
                        <div className="cita-value">{turnoSeleccionado.dias[0].horaInicio} - {turnoSeleccionado.dias[0].horaFin}</div>
                      </div>
                    </div>
                    <div className="cita-field-card">
                      <FontAwesomeIcon icon={faRedo} className="cita-icon" />
                      <div>
                        <div className="cita-label">Periodicidad</div>
                        <div className="cita-value">{periodicidad}</div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="cita-field-card">
                      <FontAwesomeIcon icon={faCalendarAlt} className="cita-icon" />
                      <div>
                        <div className="cita-label">Fecha</div>
                        <input type="date" value={nuevaFecha} onChange={e => setNuevaFecha(e.target.value)} className="cita-input" />
                      </div>
                    </div>
                    <div className="cita-field-card">
                      <FontAwesomeIcon icon={faClock} className="cita-icon" />
                      <div>
                        <div className="cita-label">Hora inicio</div>
                        <input type="time" value={nuevaHoraInicio} onChange={e => setNuevaHoraInicio(e.target.value)} className="cita-input" />
                        <div className="cita-label" style={{ marginTop: 8 }}>Hora fin</div>
                        <input type="time" value={nuevaHoraFin} onChange={e => setNuevaHoraFin(e.target.value)} className="cita-input" />
                      </div>
                    </div>
                    <div className="cita-field-card">
                      <FontAwesomeIcon icon={faRedo} className="cita-icon" />
                      <div>
                        <div className="cita-label">Periodicidad</div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <select value={periodicidad} onChange={e => setPeriodicidad(e.target.value)} className="cita-input">
                            <option value="">Seleccione</option>
                            <option value="Semanal">Semanal</option>
                            <option value="Quincenal">Quincenal</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <button
                className="btnBlue cita-add-btn"
                onClick={handleAgregarUnaCita}
                disabled={citasProgramadas.length >= 4}
              >
                <FontAwesomeIcon icon={faPlusCircle} style={{ marginRight: 8 }} />
                Agregar una cita
              </button>
              <div className="citas-futuras-list">
                <div className="citas-futuras-title">
                  <FontAwesomeIcon icon={faListAlt} className="cita-icon" />
                  <b>Citas futuras:</b> (Maximo 4 citas programadas)
                </div>
                {citasProgramadas && citasProgramadas.length > 0 ? (
                  <ul className="citas-futuras-ul">
                    {citasProgramadas.map((cita, idx) => {
                      const fechaMoment = moment(cita.dias[0].dia);
                      const diaSemana = fechaMoment.format('dddd');
                      const fechaFormateada = fechaMoment.format('D [de] MMMM [de] YYYY');
                      return (
                        <li key={cita.idTurno} className="citas-futuras-li">
                          <FontAwesomeIcon icon={faCalendarAlt} className="cita-icon-sm" />
                          <span className="cita-futura-text">{diaSemana} {fechaFormateada} de {cita.dias[0].horaInicio} a {cita.dias[0].horaFin}hrs.</span>
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <div className="citas-futuras-empty">No hay citas futuras programadas.</div>
                )}
              </div>
            </div>
          )}

          {/* HISTORIAL */}
          {tab === 'historial' && (
            <div className="card-section">
              <div className="timeline">
                {citasHistorial.map((cita, i) => {
                  const [anioStr, mesStr, diaStr] = cita.dias[0].dia.split('-');
                  const fecha = new Date(parseInt(anioStr), parseInt(mesStr) - 1, parseInt(diaStr));
                  const diasSemana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
                  const diaSemana = diasSemana[fecha.getDay()];
                  return (
                    <div className="timeline-event" key={cita.idTurno}>
                      <div className="timeline-dot" />
                      <div className="timeline-content">
                        <div><b>Sesión {i + 1}</b>: {diaSemana} {cita.dias[0].dia} de {cita.dias[0].horaInicio} a {cita.dias[0].horaFin}hrs.</div>
                        <div><b>Estatus:</b> {cita.estado}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* COMENTARIOS */}
          {tab === 'comentarios' && (
            <>
              <div className="card-section comentarios-add-card">
                <fieldset className="comentarios-add-fieldset">
                  <textarea
                    placeholder="Agregar comentario.."
                    value={nuevoComentario}
                    onChange={e => setNuevoComentario(e.target.value)}
                    id="comentario"
                    rows={3}
                    className="comentarios-add-textarea"
                  />
                </fieldset>
                <div className="comentarios-btns-row">
                  <button className="btnGrey" onClick={() => checkComentarioCompleto(1)}>
                    Guardar sólo el comentario
                  </button>
                  <button className="btnGreen" onClick={() => checkComentarioCompleto(2)}>
                    Dar de alta paciente
                  </button>
                </div>
                <button className="btnBlue comentarios-btn-agendar" onClick={() => checkComentarioCompleto(3)}>
                  Guardar comentario | Agendar 4 citas
                </button>
              </div>
              <div className="card-section comentarios-timeline">
                <div className="comentarios-timeline-list">
                  {comentarios && comentarios.length > 0 ? (
                    [...comentarios].sort((a, b) => new Date(b.fecha) - new Date(a.fecha)).map((c, idx) => (
                      <div className="comentario-timeline-item" key={c.idComentario}>
                        <div className="comentario-timeline-dot" />
                        <div className="comentario-timeline-content compact">
                          <div className="comentario-timeline-header">
                            <span className="comentario-timeline-user"><FaUser style={{ marginRight: 6 }} />{c.nombre}</span>
                            <span className="comentario-timeline-date"><FaClock style={{ marginRight: 4 }} />{c.fecha}</span>
                          </div>
                          <div className="comentario-timeline-text">{c.comentario}</div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="comentarios-timeline-empty"><FaComment style={{ marginRight: 8 }} />No hay comentarios aún.</div>
                  )}
                </div>
              </div>
            </>
          )}

          {/* CANCELAR */}
          {tab === 'cancelar' && (
            <div className="card-section cancel-section">
              <div className="cancel-list">
                {citasProgramadas && citasProgramadas.length > 0 ? (
                  citasProgramadas.map((cita) => {
                    const [anioStr, mesStr, diaStr] = cita.dias[0].dia.split('-');
                    const fecha = new Date(parseInt(anioStr), parseInt(mesStr) - 1, parseInt(diaStr));
                    const diasSemana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
                    const diaSemana = diasSemana[fecha.getDay()];
                    return (
                      <div className="cancel-checkbox-row" key={cita.idTurno}>
                        <input
                          type="checkbox"
                          name="cita"
                          value={cita.idTurno}
                          checked={citasSeleccionadas.includes(cita.idTurno)}
                          onChange={handleCheckboxChange}
                          disabled={selecciones.todas}
                        />
                        <span>{diaSemana} {cita.dias[0].dia} de {cita.dias[0].horaInicio} a {cita.dias[0].horaFin}hrs.</span>
                      </div>
                    );
                  })
                ) : (
                  <div>No hay próximas sesiones programadas.</div>
                )}
              </div>
              <button
                className="cancel-btn-fixed"
                onClick={() => {
                  handleCancelar();
                  setCitasSeleccionadas([]);
                }}
                disabled={isDisabled}
              >
                Cancelar seleccionadas
              </button>
            </div>
          )}

          {/* PACIENTES */}
          {tab === 'pacientes' && (
            <>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: "20px", flexWrap: 'wrap' }}>
                <button className='btnGreen' onClick={() => { handleOpenDatosPacienteNuevoModal(); }}>Agregar Nuevo</button>
                <button className='btnBlue' onClick={() => setModalSeleccionarPacienteIsOpen(true)}>Agregar de la lista</button>
                <div className="file-upload-container" style={{ position: 'relative', display: 'inline-block' }}>
                  <input
                    type="file"
                    id="excel-upload"
                    accept=".xlsx, .xls"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    disabled={isUploading}
                  />
                  <label
                    htmlFor="excel-upload"
                    className={`btnGrey ${isUploading ? 'disabled' : ''}`}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px',
                      cursor: isUploading ? 'not-allowed' : 'pointer',
                      opacity: isUploading ? 0.7 : 1
                    }}
                  >
                    {isUploading ? (
                      <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Cargando...
                      </>
                    ) : (
                      <>
                        Cargar desde Excel
                      </>
                    )}
                  </label>
                </div>
              </div>
              {pacientes.map((paciente, i) => {
                return (
                  <div className="card-section" key={paciente.id}>
                    <div><b>{i + 1}/{pacientes.length}</b></div>
                    <div><b>Nombre:</b> {paciente.nombre}</div>
                    <div><b>Teléfono:</b> {paciente.telefono}</div>
                    <div><b>Edad:</b> {paciente.edad}</div>
                    <div><b>Sexo:</b> {paciente.sexo}</div>
                    <div><b>Escolaridad:</b> {paciente.escolaridad}</div>
                    <div><b>Estado Civil:</b> {paciente.estadoCivil}</div>
                    <div><b>Ocupación:</b> {paciente.ocupacion}</div>
                    <div><b>Servicios Salud:</b> {paciente.servicioSalud}</div>
                    <div><b>Religion:</b> {paciente.religion}</div>
                    <div><b>Municipio:</b> {paciente.municipio}</div>
                    <div><b>Motivo Consulta:</b> {paciente.motivoConsulta}</div>
                    <div><b>Cómo se enteró:</b> {paciente.comoEntero}</div>
                    <div style={{ "display": "flex", marginTop: "20px" }}>
                      <button className='btnBlue' style={{ margin: "5px", width: "170px" }} onClick={() => { handleOpenDatosPacienteExistenteModal(paciente.id); }}>Editar</button>
                      <button className='btnRed' style={{ margin: "5px", width: "170px" }} onClick={() => { borrarPaciente(paciente.id, paciente.nombre); }}>Borrar</button>
                    </div>
                  </div>
                );
              })}


            </>
          )}
        </div>
      </Modal>
      <Modal
        isOpen={modalDatosPacienteIsOpen}
        onRequestClose={handleCloseDatosPacienteModal}
        ariaHideApp={false}
        className="modal-datos-paciente"
        overlayClassName="overlay-admin"
      >
        <div className='header'>
          <h4>Datos del Paciente</h4>
        </div>
        <div className='flexGrap'>
          <fieldset>
            <legend>Nombre: (*)</legend>
            <input
              type="text"
              value={nombrePaciente}
              onChange={(e) => setNombrePaciente(e.target.value)}
            />
          </fieldset>

          <fieldset>
            <legend>Teléfono: (*)</legend>
            <input
              type="text"
              value={telefonoPaciente}
              onChange={(e) => setTelefonoPaciente(e.target.value)}
            />
          </fieldset>

          <fieldset>
            <legend>Edad: (*)</legend>
            <input
              type="number"
              value={edadPaciente}
              onChange={(e) => setEdadPaciente(e.target.value)}
            />
          </fieldset>

          <fieldset>
            <legend>Sexo: (*)</legend>
            <select
              value={sexo}
              onChange={(e) => {
                setSexo(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoSexo.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

          <fieldset>
            <legend>Escolaridad:</legend>
            <select
              value={escolaridad}
              onChange={(e) => {
                setEscolaridad(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoEscolaridad.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

          <fieldset>
            <legend>Estado Civil:</legend>
            <select
              value={estadoCivil}
              onChange={(e) => {
                setEstadoCivil(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoEstadoCivil.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

          <fieldset>
            <legend>Ocupación:</legend>
            <input
              type="text"
              value={ocupacion}
              onChange={(e) => setOcupacion(e.target.value)}
            />
          </fieldset>

          <fieldset>
            <legend>Acceso a servicios de salud:</legend>
            <select
              value={servicioSalud}
              onChange={(e) => {
                setServicioSalud(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoServiciosSalud.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

          <fieldset>
            <legend>Religión:</legend>
            <select
              value={religion}
              onChange={(e) => {
                setReligion(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoReligiones.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

          <fieldset>
            <legend>Municipio:</legend>
            <select
              value={municipio}
              onChange={(e) => {
                setMunicipio(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoMunicipios.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

          <fieldset>
            <legend>Motivo de Consulta:</legend>
            <select
              value={motivoConsulta}
              onChange={(e) => {
                setMotivoConsulta(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoMotivosConsulta.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

          <fieldset>
            <legend>¿Cómo se enteró de CESECO?</legend>
            <select
              value={comoEntero}
              onChange={(e) => {
                setComoEntero(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoComoEntero.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

        </div>

        <div className='footer'>
          <button
            onClick={guardarPaciente}
            className="btnPost"
          >
            Guardar
          </button>



        </div>
      </Modal>

      {/* Modal para seleccionar paciente existente */}
      <Modal
        isOpen={modalSeleccionarPacienteIsOpen}
        onRequestClose={() => setModalSeleccionarPacienteIsOpen(false)}
        className="modal-datos-paciente"
        overlayClassName="overlay-admin"
      >
        <div className='header'>
          <h4>Seleccionar Paciente</h4>
        </div>
        <div className='flexGrap' style={{ padding: '20px' }}>
          <div style={{ width: '100%', marginBottom: '20px' }}>
            <label>Selecciona un paciente:</label>
            <select
              className="form-control"
              value={pacienteSeleccionado}
              onChange={(e) => setPacienteSeleccionado(e.target.value)}
              style={{ width: '100%', padding: '8px', marginTop: '5px' }}
            >
              <option value="">-- Selecciona un paciente --</option>
              {allPacientes.map(paciente => (
                <option key={paciente.id} value={paciente.id}>
                  {paciente.nombre} - {paciente.telefono || 'Sin teléfono'}
                </option>
              ))}
            </select>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', width: '100%' }}>
            <button className='btnRed' onClick={() => setModalSeleccionarPacienteIsOpen(false)}>Cancelar</button>
            <button
              className='btnGreen'
              onClick={() => {
                if (pacienteSeleccionado) {
                  const paciente = allPacientes.find(p => p.id == pacienteSeleccionado);
                  if (paciente) {
                    // Verificar si el paciente ya está inscrito en este taller
                    const yaInscrito = pacientes.some(p => p.id === paciente.id);
                    if (yaInscrito) {
                      Swal.fire('Aviso', 'Este paciente ya está inscrito en el taller', 'warning');
                      return;
                    }
                    inscribirPacienteExistente(paciente);
                  }
                } else {
                  Swal.fire('Aviso', 'Por favor selecciona un paciente', 'warning');
                }
              }}
            >
              Guardar
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TurnoModal;
